var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#F8F8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6666 7.87364C19.4833 7.13727 18.9411 6.55636 18.2514 6.35727C17.0041 6 12 6 12 6C12 6 6.99841 6 5.74865 6.35727C5.06141 6.55364 4.51925 7.13455 4.33344 7.87364C4 9.21 4 12 4 12C4 12 4 14.79 4.33344 16.1264C4.5167 16.8627 5.05886 17.4436 5.74865 17.6427C6.99841 18 12 18 12 18C12 18 17.0041 18 18.2514 17.6427C18.9386 17.4464 19.4808 16.8655 19.6666 16.1264C20 14.79 20 12 20 12C20 12 20 9.21 19.6666 7.87364Z",
    fill: "#80899C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4015 14.5718L14.5581 12L10.4015 9.42818V14.5718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.0ecd33b223c628e83aaaf983ff0066f0.svg";
export { ForwardRef as ReactComponent };